export class Model_Forex_CRM_OrganisationType
    {      
  
    public OrganisationTypeId : number;
    public OrganisationType   :string;
                   
    }       